import { createSelector } from "@reduxjs/toolkit";

export const selectWatchwordsListState = (state) => state?.watchwords.list;

export const selectWatchwordsList = createSelector(
  [selectWatchwordsListState],
  (list) => list.data
);
